import { SET_IS_OPEN } from '../../../types/conversations/plugins'

const initVirtualAssistantState = {
  isOpen: false
}

export default function virtualAssistant(state = initVirtualAssistantState, action) {
  switch (action.type) {
    case SET_IS_OPEN: {
      const { isOpen } = action
      return Object.assign({}, state, { isOpen })
    }
    default: {
      return state
    }
  }
}
